/**
 * Auto Login System for E-Learning Platform
 * Automatically logs in users to bypass caching issues
 */

class AutoLogin {
    constructor() {
        this.storageKey = 'auto_login_user';
        this.init();
    }

    init() {
        // Temporarily disabled auto-login for debugging
        console.log('Auto-login disabled for debugging');
        // Check if we need to auto-login
        // if (!this.isLoggedIn()) {
        //     this.performAutoLogin();
        // }
    }

    /**
     * Check if user is currently logged in
     */
    isLoggedIn() {
        return document.cookie.includes('user=');
    }

    /**
     * Perform automatic login
     */
    async performAutoLogin() {
        try {
            // Get or create user data
            let userData = this.getStoredUserData();
            
            if (!userData) {
                // Create new user data
                userData = {
                    name: 'Auto User',
                    company: 'Auto Company',
                    email: 'auto@example.com',
                    uid: this.generateUID()
                };
                
                // Save to localStorage for future use
                this.saveUserData(userData);
            }

            // Set the cookie that the server expects
            this.setUserCookie(userData.uid);
            
            // Reload the page to apply the login
            window.location.reload();
            
        } catch (error) {
            console.error('Auto login failed:', error);
        }
    }

    /**
     * Generate a unique user ID
     */
    generateUID() {
        return 'auto_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }

    /**
     * Set the user cookie that the server expects
     */
    setUserCookie(uid) {
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        document.cookie = `user=${uid}; expires=${expires.toUTCString()}; path=/`;
    }

    /**
     * Get stored user data from localStorage
     */
    getStoredUserData() {
        try {
            const data = localStorage.getItem(this.storageKey);
            return data ? JSON.parse(data) : null;
        } catch (error) {
            console.error('Error reading stored user data:', error);
            return null;
        }
    }

    /**
     * Save user data to localStorage
     */
    saveUserData(userData) {
        try {
            localStorage.setItem(this.storageKey, JSON.stringify(userData));
            return true;
        } catch (error) {
            console.error('Error saving user data:', error);
            return false;
        }
    }

    /**
     * Create user post on server (optional)
     */
    async createUserPost(userData) {
        try {
            const formData = new FormData();
            formData.append('action', 'create_auto_user');
            formData.append('name', userData.name);
            formData.append('company', userData.company);
            formData.append('email', userData.email);
            formData.append('uid', userData.uid);
            formData.append('_wpnonce', (window.elearningAjax && window.elearningAjax.nonce) || '');

            const restUrl = (window.elearningAjax && window.elearningAjax.restUrl) || '/wp-json/elearning/v1/';
            const response = await axios.post(restUrl + 'login', {
                field_name: userData.name,
                field_company: userData.company,
                field_email: userData.email
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': (window.elearningAjax && window.elearningAjax.nonce) || ''
                }
            });

            return response.data && response.data.uid;
        } catch (error) {
            console.error('Error creating user post:', error);
            return false;
        }
    }
}

// Initialize auto login when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    window.autoLogin = new AutoLogin();
}); 